<template>
  <div>
    <b-modal
      id="delete-member"
      ref="delete-member"
      size="entry-delete"
      centered
      hide-footer
      hide-header
      @hide="close"
    >
      <div class="modal-head">
        <span class="modal-title">{{ label.get('delete') }} {{ type }}?</span>
      </div>
      <div class="content-wrapper">
        <div class="field-row">
          <p v-html="label.get('delete_modal_body', {name: type})" />
        </div>
      </div>
      <div class="modal-footer">
        <button
          class="cancel atto-btn"
          @click="close"
        >
          {{ label.get('cancel') }}
        </button>
        <button
          class="atto-btn delete"
          @click="deleteMember"
        >
          {{ label.get('delete') }}
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
    import MemberService from '../services/MemberService';
    export default {
        name: "DeleteMemberComponent",
        props: {
            id: {
              type: Number,
              default: 0
            },
            type: {
              type: String,
              default: 'invite'
            }
        },
        mounted(){
            document.body.appendChild(this.$el);
            this.$refs['delete-member'].show();
        },
        methods: {
            deleteMember(){
              debugger;
                if(this.type) {
                    this.$store.commit('showLoading');
                    if(this.type === 'member') {
                        MemberService.deleteMember(this.id).then((result) => {
                            this.$store.commit('hideLoading');
                            this.$root.$emit("hideDeleteMember", { id: this.id, type: 'member'});
                        }).catch((error) => {
                            this.$store.commit('hideLoading');
                        });
                    }
                    else {
                        MemberService.deleteInvite(this.id).then((result) => {
                            this.$store.commit('hideLoading');
                            this.$root.$emit("hideDeleteMember", { id: this.id, type: 'invite'});
                        }).catch((error) => {
                            this.$store.commit('hideLoading');
                        });
                    }
                }
                else {
                    this.$root.$emit("hideDeleteMember");
                }
            },
            close(){
                this.$root.$emit("hideDeleteMember");
            }
        }
    }
</script>
